export default function VisualProof() {
  const videos = [
    {
      thumbnail: 'https://public.readdy.ai/ai/img_res/f6a9eec732ac78435990d70bbbb94523.jpg',
      title: 'Workshop Highlights',
      duration: '2:34'
    },
    {
      thumbnail: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20immersive%20technology%20setup%20for%20corporate%20event%2C%20Unreal%20Engine%20projection%20mapping%2C%20technical%20crew%20preparing%20equipment%2C%20LED%20screens%20displaying%20virtual%20environments%2C%20professional%20production%20quality%2C%20modern%20tech%20aesthetic%2C%20dark%20atmospheric%20lighting&width=800&height=600&seq=video-thumb-002&orientation=landscape',
      title: 'Behind The Scenes',
      duration: '1:58'
    },
    {
      thumbnail: 'https://readdy.ai/api/search-image?query=Corporate%20team%20members%20celebrating%20success%20together%20after%20workshop%2C%20happy%20expressions%2C%20high-fiving%2C%20group%20photo%20moment%2C%20inclusive%20diverse%20team%2C%20professional%20event%20setting%2C%20authentic%20emotions%2C%20natural%20lighting%2C%20positive%20team%20culture&width=800&height=600&seq=video-thumb-003&orientation=landscape',
      title: 'Team Testimonials',
      duration: '3:12'
    }
  ];

  return (
    <section className="py-32 bg-gradient-to-b from-black to-[#0A0A0F]">
      <div className="max-w-7xl mx-auto px-6">
        {/* Video Section */}
        <div>
          <h2 className="text-5xl md:text-6xl font-bold text-white text-center mb-6">
            See Our Instructors in Action
          </h2>
          <p className="text-gray-300 text-xl text-center max-w-3xl mx-auto mb-16">
            Watch how teams transform through immersive experiences and collaborative movement
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {videos.map((video, index) => (
              <div 
                key={index}
                className="group relative rounded-2xl overflow-hidden cursor-pointer hover:shadow-2xl hover:shadow-cyan-500/20 transition-all duration-300 hover:-translate-y-2"
              >
                <div className="aspect-video relative">
                  <img 
                    src={video.thumbnail}
                    alt={video.title}
                    className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-black/40 group-hover:bg-black/20 transition-colors"></div>
                  
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-20 h-20 rounded-full bg-white/90 flex items-center justify-center group-hover:bg-cyan-400 group-hover:scale-110 transition-all">
                      <i className="ri-play-fill text-4xl text-black ml-1"></i>
                    </div>
                  </div>

                  <div className="absolute top-4 right-4 px-3 py-1 bg-black/80 rounded-full text-white text-sm font-semibold">
                    {video.duration}
                  </div>
                </div>

                <div className="p-6 bg-[#16213E]">
                  <h3 className="text-xl font-bold text-white">{video.title}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <a 
            href="#contact" 
            className="inline-flex items-center gap-3 px-10 py-4 bg-gradient-to-r from-cyan-400 to-blue-500 rounded-full text-white font-bold text-lg hover:shadow-2xl hover:shadow-cyan-500/50 transition-all hover:-translate-y-1 cursor-pointer whitespace-nowrap"
          >
            Request Full Workshop Video
            <i className="ri-arrow-right-line text-xl"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
